import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .clark-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        var(--top-padding-height);
      max-width: 100%;
      align-items: end;
    }

    h2 {
      line-height: unset;
      padding-bottom: calc(20rem / var(--default-rem-px-count));
    }

    h3 {
      line-height: unset;
      padding-top: calc(14rem / var(--default-rem-px-count));
      font-size: 0.825em;
    }

    cta-text {
      padding-top: calc(14rem / var(--default-rem-px-count));
    }

    img {
      max-width: 100%;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(40rem / var(--default-rem-px-count));
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 3;
      display: flex;
      flex-wrap: wrap;
      gap: calc(40rem / var(--default-rem-px-count));
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
    }

    .image-description {
      padding-top: calc(14rem / var(--default-rem-px-count));
      font-size: 0.825em;
      line-height: 1.45em;
    }

    .image-wrapper {
      width: 100%;
    }

    .image {
      width: 100%;
      aspect-ratio: 3 / 2;
      border: 0.5px solid #222222;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .text-sections-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .text-section {
      padding-top: calc(14rem / var(--default-rem-px-count));
      font-size: 0.825em;
      line-height: 1.45em;
    }

    @media (min-width: 600px) {
      .clark-layout {
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          var(--top-padding-height);
        align-items: start;
      }

      h2 {
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      h3 {
        line-height: unset;
        padding-top: calc(20rem / var(--default-rem-px-count));
      }

      cta-text {
        padding-top: calc(20rem / var(--default-rem-px-count));
      }

      .header {
        grid-column: 2 / 5;
        grid-row: 2;
      }

      .images {
        grid-column: 6 / 12;
        grid-row: 2;
        gap: calc(2 * var(--between-column-padding))
          var(--between-column-padding);
      }

      .image {
        aspect-ratio: 1 / 1;
      }

      .image-wrapper {
        width: calc(50% - calc(var(--between-column-padding) / 2));
      }
    }
  `,
];
